import { useRoute } from "@bcm-dev/bcms-vite";
import { Biller } from "model/";
import React from 'react';
import { ImageAsset } from "res";
import "./styles.css";

/**
 * @function BillerInfoView
 * @return {React.Component}
 * @param {Biller} biller - Selected biller.
 * @param {String} logo - Selected biller logo.
 * @param {String} name - Selected biller name.
 * @param {String} tab - Selected tab in the workflow.
 * @param {String} dataPoint - A prefix string for data points in this component. 
 * A biller id is used as a suffix to make the data point unique
 * since this component often appears multiple times in a single page, like "Pay Bills" or "Activity".
 * @exported true
 * @description This is a component shown through the demo that displays biller info in a rectangular white widget.
 */
export default function BillerInfoView(props) {
    const biller = props.biller instanceof Biller ? props.biller : Biller.firstInstanceOf();

    const logo = biller.logo ?? "CompanyBillerImage";
    const name = biller.name ?? "[Biller]";
    const tab = props.tab ?? "details";
    const description = biller.nickname ?? "[Biller Description]";
    const accountNumber = biller.number ?? "[Account Number]";
    const navigate = useRoute();
    const hasBillerNameLinkClick = props.hasBillerNameLinkClick ?? true;
    const linkClick = () => {
      if(hasBillerNameLinkClick) {
        navigate( `/billerDetails/${tab}/${ biller.id }`,{state:{"goBack":"true"}})
      }
    }

    const nameDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Name_" + biller.id } : {};
    const descriptionDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Description_" + biller.id } : {};
    const accountNumberDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Number_" + biller.id } : {};

    return (
        <div className="flex-container flex-horizontal flex-height biller-info-view-container align-center">
            <div className="set-width image-container justify-right">
              <ImageAsset id={ logo } className="logo-icon left-icon" />
            </div>
            <div className="flex-container flex-vertical flex-width">
              <h2 className="main-text">
                <a onClick={linkClick} { ...nameDataPoint }>
                  { name }
                </a>
              </h2>
              <p className="gray-text sub-text flex-container flex-horizontal">
                <span className="biller-description" { ...descriptionDataPoint }>{ description }</span>
                <span { ...accountNumberDataPoint }>{ accountNumber }</span>
              </p>
            </div>
          </div>
    );
  }